import request from '@/utils/request'
import { getLyXTenantId } from '@/utils/auth'
function getExpertToken() {
  return localStorage.getItem('expert_token')
}
// 项目列表
export function queryList(params) {
  return request({
    url: '/api/option/activity/queryList',
    method: 'get',
    params,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 项目列表
export function activityDrawQueryList(params) {
  return request({
    url: '/api/option/activity/activityDrawQueryList',
    method: 'get',
    params,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 新增路演
export function addFull(data) {
  return request({
    url: '/api/option/activity/add-full',
    method: 'post',
    data,
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 获取路演
export function getInfo(id) {
  return request({
    url: `/api/option/activity/getInfo/${id}`,
    method: 'get',
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 新增路演
export function update(data) {
  return request({
    url: '/api/option/activity/update',
    method: 'post',
    data,
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 根据ID删除活动
export function delActivity(id) {
  return request({
    url: '/api/option/activity/del',
    method: 'post',
    headers: {
      'X-Tenant-Id': getLyXTenantId()
    },
    data: {id: id}
  })
}

// 查询所有活动主题
export function activityThemes(params) {
  return request({
    url: '/api/option/roadshow-project/activity-themes',
    method: 'get',
    params,
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 通过活动主题名称查询所有活动
export function byTheme(params) {
  return request({
    url: '/api/option/roadshow-project/projects/by-theme',
    method: 'get',
    params,
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 设置专家头像
export function updateAvatar(data) {
  return request({
    url: '/api/option/review-expert/update_avatar',
    method: 'post',
    data,
    headers: {
      'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 生成专家二维码
export function buildPdf(params) {
  return request({
    url: '/api/option/score/generate-qr/docx-pdf',
    method: 'get',
    params,
    headers: {
      'X-Tenant-Id': getLyXTenantId()
    },
    responseType: 'blob' // 关键：按文件流处理
  })
}

// 路演控制
export function broadcast(data) {
  return request({
    url: `/api/option/score/broadcast `,
    method: 'post',
    data,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 路演开始
export function activityStart(data) {
  return request({
    url: `/api/option/activity/activity-start `,
    method: 'post',
    data,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 控制面板保存或更新
export function saveOrUpdate(data) {
  return request({
    url: `/api/option/control-panel/saveOrUpdate`,
    method: 'post',
    data,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 活动项目列表
export function activityProjectList(data) {
  return request({
    url: `/option/activity-project/list`,
    method: 'get',
    params: data
  })
}

// 新增：更新活动项目状态
export function updateActivityProject(data) {
  return request({
    url: '/api/option/activity-project/update',
    method: 'post',
    data,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 项目排序
export function drawSort(data) {
  return request({
    url: '/option/activity-project/drawSort ',
    method: 'post',
    data
  })
}

export function projectExpertScores(params) {
  return request({
    url: '/api/option/score/project-expert-scores',
    method: 'get',
    params
  })
}

// 新增：评分初始化（用 token 初始化专家、维度、项目）
export function scoreInit(params) {
  return request({
    url: '/api/option/score/init',
    method: 'get',
    params,
    headers: {
      'Expert-Token': getExpertToken()
    }
  })
}

export function scoreSubmit(data) {
  return request({
    url: '/api/option/score/submit',
    method: 'post',
    data
  })
}

export function generateAudienceQr(params) {
  return request({
    url: '/option/activity/generate-audience-qr',
    method: 'get',
    params
  })
}

export function exportAudienceQrDocx(params) {
  return request({
    url: '/api/option/activity/audience-qr/docx-pdf',
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

export function getAudienceQrStat(params) {
  return request({
    url: '/api/option/activity/audience-qr/stat',
    method: 'get',
    params,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

export function exportInvestorQrDocx(params) {
  return request({
    url: '/api/option/investor/generate-qr/docx-pdf',
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

export function audienceInit(params) {
  return request({
    url: '/api/option/audience/init',
    method: 'get',
    params
  })
}

export function audienceSubmit(data) {
  return request({
    url: '/api/option/audience/submit',
    method: 'post',
    data
  })
}

export function audienceCountsCurrent(params) {
  return request({
    url: '/api/option/audience/counts/current',
    method: 'get',
    params
  })
}

// 投资人登录（返回 investorId）
export function investorLogin(data) {
  return request({
    url: '/option/investor/login',
    method: 'post',
    data
  })
}

export function exportCompletedActivityDetail(params) {
  return request({
    url: '/api/option/activity/export-completed',
    method: 'get',
    params,
    responseType: 'blob',
    headers: {
      'X-Tenant-Id': getLyXTenantId()
    }
  })
}

// 投资人评审初始化
export function investorInit(params) {
  return request({
    url: '/api/option/investor/init',
    method: 'get',
    params
  })
}

// 投资人提交评审（打分/意向）
export function investorSubmit(data) {
  return request({
    url: '/api/option/investor/submit',
    method: 'post',
    data
  })
}

export function investorList(params) {
  return request({
    url: '/api/option/investor/list',
    method: 'get',
    params,
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

export function statusSummary(params) {
  return request({
    url: '/api/option/activity/status-summary',
    method: 'get',
    params,
      headers: {
       'X-Tenant-Id': getLyXTenantId()
    }
  })
}

export function downloadByUrl(params) {
  return request({
    url: '/sys/file/downloadByUrl',
    method: 'get',
    params,
    headers: {
      'X-Tenant-Id': getLyXTenantId()
    },
  })
}
// 素材列表
export function materialList(params) {
  return request({
    url: '/api/material/getSimpleList',
    method: 'get',
    headers: {
       'X-Tenant-Id': getLyXTenantId()
    },
    params
  })
}
